import { z } from 'zod';

import type { SystemDiskRecord } from '../../../capabilities/image-vm/types';
import type { ServiceFormItem } from '../../../capabilities/service/types';

export const EbmSpecSchema = z.object({
  alias: z.string(),
  description: z.string().optional(),
  // optional：自定义 SKU 未勾选 systemSetting 时 enabledModules 会 strip 为 undefined（对齐 VM）
  runStrategy: z.string().optional(),
  workspace: z.string().optional(),
  datacenter: z.string().optional(),
  optionMeta: z.record(z.string(), z.unknown()).optional(),
  system: z
    .object({
      architecture: z.string(),
      os: z.string(),
      version: z.string(),
      bootloader: z.string().optional(),
      url: z.string().optional(),
      requirement: z.string().optional(),
      image: z.string().optional(),
      source: z.unknown().optional(),
    })
    .optional(),
  systemDisk: z.custom<SystemDiskRecord>().optional(),
  resourceConfigurationRaw: z.string().optional(),
  resource: z.object({
    cpu: z.record(z.string(), z.unknown()).optional(),
    memory: z.record(z.string(), z.unknown()).optional(),
    gpu: z.record(z.string(), z.unknown()).optional(),
    network: z.object({
      vpc: z.string().optional(),
      subnet: z.string().optional(),
      securitygroup: z.string().optional(),
      dnsConfig: z
        .object({
          nameservers: z.array(z.string()).optional(),
          searches: z.array(z.string()).optional(),
          options: z.array(z.object({ name: z.string(), value: z.string().optional() })).optional(),
        })
        .optional(),
      // nullish：兼容接口 / JSON 反序列化后的 null
      service: z.array(z.custom<ServiceFormItem>()).nullish(),
      nic: z.array(z.record(z.string(), z.unknown())).nullish(),
    }),
    storage: z
      .object({
        device: z.array(z.record(z.string(), z.unknown())).nullish(),
        volume: z.array(z.record(z.string(), z.unknown())).nullish(),
      })
      .nullish(),
  }),
});

export type EbmSpec = z.infer<typeof EbmSpecSchema>;

export type EbmApiPayload = Record<string, unknown>;
